import {
    FETCH_EDJBA_FILTERLIST,
    FETCH_EDJBA_FILTERLIST_SUCCESS,
    FETCH_EDJBA_FILTERLIST_FAILED,
    FETCH_WIRELINE_ACH,
    FETCH_WIRELINE_ACH_SUCCESS,
    FETCH_WIRELINE_ACH_FAILED,
    FETCH_WIRELINE_PLANCOUNT,
    FETCH_WIRELINE_PLANCOUNT_SUCCESS,
    FETCH_WIRELINE_PLANCOUNT_FAILED,
    FETCH_WIRELINE_PLAN_CSV,
    FETCH_WIRELINE_PLAN_CSV_SUCCESS,
    FETCH_WIRELINE_PLAN_CSV_FAILED,
    SHOW_ALERT_ED1,
    HIDE_ALERT_ED1,
    RESET_ED1,

    FETCH_WIRELINE_ENT_PERF,
    FETCH_WIRELINE_ENT_PERF_SUCCESS,
    FETCH_WIRELINE_ENT_PERF_FAILED,
    FETCH_NEW_ACQ,
    FETCH_NEW_ACQ_SUCCESS,
    FETCH_NEW_ACQ_FAILED,
    FETCH_NEW_ACQ_CSV,
    FETCH_NEW_ACQ_CSV_SUCCESS,
    FETCH_NEW_ACQ_CSV_FAILED,
    FETCH_UPGRADE_BY_PRODUCT,
    FETCH_UPGRADE_BY_PRODUCT_FAILED,
    FETCH_UPGRADE_BY_PRODUCT_SUCCESS,
    FETCH_UPGRADE_CSV,
    FETCH_UPGRADE_CSV_SUCCESS,
    FETCH_UPGRADE_CSV_FAILED,
    FETCH_TIMESTAMP,
    FETCH_TIMESTAMP_SUCCESS,
    FETCH_TIMESTAMP_FAILED,
    SET_SELECTED_DATA,
    TOGGLE_DATE_ALERT,
    TOGGLE_ERROR_ALERT,
    FETCH_SCHEME_NAME,
    FETCH_SCHEME_NAME_SUCCESS,
    FETCH_SCHEME_NAME_FAILED,
    FETCH_SCHEME_TYPE,
    FETCH_SCHEME_TYPE_SUCCESS,
    FETCH_SCHEME_TYPE_FAILED
  } from "../actions/ed1AndEd2";
  
  export const initialState = {
    ed1FilterObj: {
      loading: false,
      error: null,
      data: null,
    },
    wirelineAch: {
      loading: false,
      error: null,
      data: null,
    },
    wirelinePlanCount: {
      loading: false,
      error: null,
      data: null,
    },
    wirelineEntPerf: {
      loading: false,
      error: null,
      data: null,
    },
    newAcq: {
      loading: false,
      error: null,
      data: null,
    },
    upgradeByProduct: {
      loading: false,
      error: null,
      data: null,
    },
    timestamp: {
      loading: false,
      error: null,
      data: null,
    },
    showAlert: false,
    showDateAlert: false,
    showErrorAlert: false,
    selectedData:{
      Region: '',
      State: '',
      'Partner Name': {},
      'Scheme Type': '',
      'Scheme Name': ''
    },
    csvLoading:{
      plan: false,
      newAcq: false,
      upgrade: false
    },
    schemeType:{
      loading: false,
      error: null,
      data: null,
    },
    schemeName:{
      loading: false,
      error: null,
      data: null,
    }
  };
  
  export function Ed1AndEd2Reducer(state = initialState, action) {
    switch (action.type) {
      case SHOW_ALERT_ED1: {
        return {
            ...state,
            showAlert: true
        }
    }
    case HIDE_ALERT_ED1: {
        return {
            ...state,
            showAlert: false
        }
    }
    case TOGGLE_DATE_ALERT: {
      return {
        ...state,
        showAlert: !state.showAlert,
        showDateAlert: !state.showDateAlert
      }
    }
    case TOGGLE_ERROR_ALERT: {
      return {
        ...state,
        showAlert: !state.showAlert,
        showErrorAlert: !state.showErrorAlert
      }
    }
      case FETCH_EDJBA_FILTERLIST:
        return {
          ...state,
          ed1FilterObj: {
            loading: true,
            error: null,
            data: null,
          },
          schemeType:{
            loading: false,
            error: null,
            data: null,
          },
          schemeName:{
            loading: false,
            error: null,
            data: null,
          }
        };
  
      case FETCH_EDJBA_FILTERLIST_SUCCESS:
        action.payload?.content.sort((a,b) => {
          return a.partnerName.split(" - ")?.[1]?.toLowerCase().localeCompare(b.partnerName.split(" - ")?.[1]?.toLowerCase())
        })
        return {
          ...state,
          ed1FilterObj: {
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case FETCH_EDJBA_FILTERLIST_FAILED:
        return {
          ...state,
          ed1FilterObj: {
            loading: false,
            error: action.error,
            data: null,
          },
        };

      case FETCH_WIRELINE_ACH :
        return {
          ...state,
          wirelineAch:{
            loading: true,
            error: null,
            data: null,
          },
        };

        case FETCH_WIRELINE_ACH_SUCCESS :
        return {
          ...state,
          wirelineAch:{
            loading: false,
            error: null,
            data: action.payload,
          },
        }

        case FETCH_WIRELINE_ACH_FAILED :
        return {
          ...state,
          wirelineAch:{
            loading: false,
            error: action.payload,
            data: null,
          },
        }

        case FETCH_WIRELINE_PLANCOUNT :
        return {
          ...state,
          wirelinePlanCount:{
            loading: true,
            error: null,
            data: null,
          },
        };

        case FETCH_WIRELINE_PLANCOUNT_SUCCESS :
        return {
          ...state,
          wirelinePlanCount:{
            loading: false,
            error: null,
            data: action.payload,
          },
        };

        case FETCH_WIRELINE_PLANCOUNT_FAILED :
        return {
          ...state,
          wirelinePlanCount:{
            loading: false,
            error: action.payload,
            data: null,
          },
        };

        case FETCH_WIRELINE_PLAN_CSV :
        return {
          ...state,
          csvLoading:{
            ...state.csvLoading,
            plan:true
          }
        };

        case FETCH_WIRELINE_PLAN_CSV_SUCCESS :
        return {
          ...state,
          csvLoading:{
            ...state.csvLoading,
            plan:false
          }
        };

        case FETCH_WIRELINE_PLAN_CSV_FAILED :
        return {
          ...state,
          csvLoading:{
            ...state.csvLoading,
            plan:false
          }
        };

        case FETCH_NEW_ACQ_CSV :
        return {
          ...state,
          csvLoading:{
            ...state.csvLoading,
            newAcq:true
          }
        };

        case FETCH_NEW_ACQ_CSV_SUCCESS :
        return {
          ...state,
          csvLoading:{
            ...state.csvLoading,
            newAcq:false
          }
        };

        case FETCH_NEW_ACQ_CSV_FAILED :
        return {
          ...state,
          csvLoading:{
            ...state.csvLoading,
            newAcq:false
          }
        };

        case FETCH_UPGRADE_CSV :
        return {
          ...state,
          csvLoading:{
            ...state.csvLoading,
            upgrade:true
          }
        };

        case FETCH_UPGRADE_CSV_SUCCESS :
        return {
          ...state,
          csvLoading:{
            ...state.csvLoading,
            upgrade:false
          }
        };

        case FETCH_UPGRADE_CSV_FAILED :
        return {
          ...state,
          csvLoading:{
            ...state.csvLoading,
            upgrade:false
          }
        };

        case FETCH_WIRELINE_ENT_PERF :
        return {
          ...state,
          wirelineEntPerf:{
            loading: true,
            error: null,
            data: null,
          },
        };

        case FETCH_WIRELINE_ENT_PERF_SUCCESS :
        return {
          ...state,
          wirelineEntPerf:{
            loading: false,
            error: null,
            data: action.payload,
          },
        }

        case FETCH_WIRELINE_ENT_PERF_FAILED :
        return {
          ...state,
          wirelineEntPerf:{
            loading: false,
            error: action.payload,
            data: null,
          },
        }

        case FETCH_NEW_ACQ :
        return {
          ...state,
          newAcq:{
            loading: true,
            error: null,
            data: null,
          },
        };

        case FETCH_NEW_ACQ_SUCCESS :
        return {
          ...state,
          newAcq:{
            loading: false,
            error: null,
            data: action.payload,
          },
        }

        case FETCH_NEW_ACQ_FAILED :
        return {
          ...state,
          newAcq:{
            loading: false,
            error: action.payload,
            data: null,
          },
        }

        case FETCH_UPGRADE_BY_PRODUCT :
        return {
          ...state,
          upgradeByProduct:{
            loading: true,
            error: null,
            data: null,
          },
        };

        case FETCH_UPGRADE_BY_PRODUCT_SUCCESS :
        return {
          ...state,
          upgradeByProduct:{
            loading: false,
            error: null,
            data: action.payload,
          },
        }

        case FETCH_UPGRADE_BY_PRODUCT_FAILED :
        return {
          ...state,
          upgradeByProduct:{
            loading: false,
            error: action.payload,
            data: null,
          },
        }

        case FETCH_TIMESTAMP :
        return {
          ...state,
          timestamp:{
            loading: true,
            error: null,
            data: null,
          },
        };

        case FETCH_TIMESTAMP_SUCCESS :
        return {
          ...state,
          timestamp:{
            loading: false,
            error: null,
            data: action.payload,
          },
        }

        case FETCH_TIMESTAMP_FAILED :
        return {
          ...state,
          timestamp:{
            loading: false,
            error: action.payload,
            data: null,
          },
        }

      case RESET_ED1 : 
      return {
        ...state,
        wirelineAch: {
          loading: false,
          error: null,
          data: null,
        },
        wirelinePlanCount: {
          loading: false,
          error: null,
          data: null,
        },
        wirelineEntPerf:{
          loading: false,
          error: null,
          data: null,
        },
        newAcq:{
          loading: false,
          error: null,
          data: null,
        },
        upgradeByProduct:{
          loading: false,
          error: null,
          data: null,
        },
      }
    case SET_SELECTED_DATA : 
      return{
        ...state,
        selectedData: action.payload
      }
    case FETCH_SCHEME_TYPE :
      return {
        ...state,
        schemeType:{
          loading: true,
          error: null,
          data: null,
        },
      };

      case FETCH_SCHEME_TYPE_SUCCESS :
      return {
        ...state,
        schemeType:{
          loading: false,
          error: null,
          data: action.payload,
        },
      }

      case FETCH_SCHEME_TYPE_FAILED :
      return {
        ...state,
        schemeType:{
          loading: false,
          error: action.payload,
          data: null,
        },
      }
    case FETCH_SCHEME_NAME :
      return {
        ...state,
        schemeName:{
          loading: true,
          error: null,
          data: null,
        },
      };

      case FETCH_SCHEME_NAME_SUCCESS :
      return {
        ...state,
        schemeName:{
          loading: false,
          error: null,
          data: action.payload,
        },
      }

      case FETCH_SCHEME_NAME_FAILED :
      return {
        ...state,
        schemeName:{
          loading: false,
          error: action.payload,
          data: null,
        },
      }
  
      default:
        return state;
    }
  }
  
  export default Ed1AndEd2Reducer;
  